export enum ProjetoVendaStatus {
  EM_PREPARACAO = 'EM_PREPARACAO',
  AGUARDANDO_INICIO = 'AGUARDANDO_INICIO',
  EM_ANDAMENTO = 'EM_ANDAMENTO',
  ENCERRADO = 'ENCERRADO',
  CANCELADO = 'CANCELADO'
}
